import './index.css';
import {renderApp as renderDevApp} from './index.development';
import {renderApp as renderProApp} from './index.production';
import {unregister} from './registerServiceWorker';
// Shared components library CSS
import '@ael/shared-components-library/dist/style.css';
import 'uno.css';

import './styles/css/editor.scss';

const rootElement: HTMLElement = document.getElementById('root') as HTMLElement;

if (process.env.NODE_ENV === 'development') {
  renderDevApp(rootElement);
} else {
  renderProApp(rootElement);
}

// Really needed right now?
if (process.env.NODE_ENV === 'production') {
  unregister();
}
